export default "__VITE_ASSET__ByPc4q2D__"